export const HEADERS = {
    headers: {
        "Content-Type": "application/json", 
        "Authorization": "Bearer " + localStorage.getItem("token")
    }
};
